import React, { useState, useEffect } from 'react';

import { Grid } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import { currentMonth, getFormatedDate } from "../../../Js/TimeAndDate";
import { getClassWiseLearners } from "../Services";

//import EnumerationCard from "../../../Components/Card/EnumerationCard";
import TopButton from '../../../Components/UI/TopButtons';
import Placeholder from "../../../Components/UI/Placeholder";
import Confirmation from "../../../Components/Modal/Confirmation";
import LearnerReportCard from './LearnerReportCard';
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

const LearnerList = (props) => {
    // Hooks
    const classes = useStyles();
    const dispatch = useDispatch();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const { loader } = useSelector((state) => state.common);

    //State    
    const [learnersReportData, setLearnersReportData] = useState([]);

    const [selectedClass, setSelectedClass] = useState(null);
    const [isActiveStatus, setIsActiveStatus] = useState(true);


    const [startOfDate, setStartOfDate] = useState(null);
    const [endOfMonth, setEndOfMonth] = useState(null);

    useEffect(() => {
        dispatch(commonSliceActions.setLoader(true));
        console.log("selectedClass",localStorage.getItem('classId'));
        if(localStorage.getItem('strtDate') != null && localStorage.getItem('endDate') != null){
            fetchClassWiseLearnerReport(localStorage.getItem('strtDate'), localStorage.getItem('endDate'));
        }
        else{
            fetchClassWiseLearnerReport(startOfDate, endOfMonth);
        }
    }, [selectedClass,localStorage.getItem('strtDate'),localStorage.getItem('endDate')]);

    useEffect(() => {
        fetchClassWiseLearnerReport();
    }, [isActiveStatus])

    useEffect(() => {
        return ()=> {
            localStorage.removeItem('strtDate');
            localStorage.removeItem('endDate');
            localStorage.removeItem('classId');
        }
    }, [])

    // Set class list
    const filterClass = (classId) => {
        let findObj = props.allClasses.find((obj) => {
            return obj.id == classId
        });
        return findObj.value || '';
    };

    const handleIsActive = (val) => {
        console.log('handleIsActive', val);
        setIsActiveStatus(val);
    };

    const handleFilterClassReport = async (childParams) => {
        //setSelectedTrainer(childParams.selectedTrainers);
        await fetchClassWiseLearnerReport(childParams.start_date, childParams.end_date, childParams.selectedTrainers);
    };

    const fetchClassWiseLearnerReport = async (start_date, end_date, created_by = []) => {

        let objCurrentMonth = currentMonth('YYYY-MM-DD');
        if (start_date == null) {
            start_date = objCurrentMonth.startOfMonth;
            setStartOfDate(start_date);
        } else {
            start_date = getFormatedDate(start_date, 'YYYY-MM-DD');
            setStartOfDate(start_date);
        }

        if (end_date == null) {
            end_date = objCurrentMonth.endOfMonth;
            setEndOfMonth(end_date);
        } else {
            end_date = getFormatedDate(end_date, 'YYYY-MM-DD');
            setEndOfMonth(end_date);
        }

        let params = {
            query: {
                'belongs_to': selectedClass,
                'site_uuid': userInfo.site_uuid,
                'start_date': start_date,
                'end_date': end_date,
                'is_active_status': isActiveStatus
            }
        };
        console.log("params===>",params);

        if (userInfo.rolesInfo.title.toLowerCase() == 'trainer') {
            params.query.created_by = [userInfo.uid];
        } else if (created_by.length > 0) {
            params.query.created_by = created_by;
        }
        let resClassWiseLearners = await getClassWiseLearners(params);
        dispatch(commonSliceActions.setLoader(false));
        setLearnersReportData(resClassWiseLearners);
    }

    const downloadClassReport = async () => {
        //Prepare CSV Data 
        if (learnersReportData.data.length > 0) {
            let csv = '';
            csv = 'Student Name, Total Active Assignments, Active Attempted Assignments, Attempted in Selected Duration, Usage [HH:MM], Status\n';
            let className = filterClass(selectedClass);

            learnersReportData.data.forEach((element) => {
                let name = element.name.firstname + ' ' + element.name.lastname;
                let totalActiveAssignments = (element.total_active_assignments) ? element.total_active_assignments : 0;
                let totalActiveAttemptedAssignment = (element.total_active_attempted_assignment) ? element.total_active_attempted_assignment : 0;
                let attemptedInSelectedDuration = (element.attempted_in_selected_duration) ? element.attempted_in_selected_duration : 0;
                let selectedDurationUsages = (element.selected_duration_usages) ? element.selected_duration_usages : '00:00';
                csv = csv + name + "," + totalActiveAssignments + "," + totalActiveAttemptedAssignment + "," + attemptedInSelectedDuration + "," + selectedDurationUsages + "," + element.status;
                csv += '\n';
            });

            let startDate = getFormatedDate(startOfDate, 'DD-MMM-YY');
            let endDate = getFormatedDate(endOfMonth, 'DD-MMM-YY');
            let fileName = startDate + '_to_' + endDate + '_' + className + '.csv';
            let hiddenElement = document.createElement('a');
            hiddenElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));

            hiddenElement.setAttribute('download', fileName);
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);
        }
    }

    return (
        <>
            <TopButton
                title={"Class Report"}
                secondaryText={getFormatedDate(startOfDate, 'DD MMM YYYY') + ' - ' + getFormatedDate(endOfMonth, 'DD MMM YYYY')}
                downloadIcon={true}
                isActiveUsers={true}
                activeText={'Active Users'}
                defaultActiveUsers={true}
                pressParentIsActive={handleIsActive}
                pressTopBtn={downloadClassReport}
                dropDownData={props.allClasses}
                fetchBySelectedValue={(classId) => { setSelectedClass(classId) }}
                isLearnerFilter={true}
                handleFilterReport={handleFilterClassReport}
            />
            <Grid
                container
                spacing={3}
                 
                sx={{ mt: 1, height: '75vh', overflow: 'auto', px: 2 }}>
                {(learnersReportData && learnersReportData.data && learnersReportData.data.length > 0) ? (
                    learnersReportData.data.map((reportData, reportIndex) => {
                        return (
                            <>
                                <Grid item
                                    xs={4}
                                    key={`reportData_${reportIndex}`}
                                    onClick={() => { props.goToLearnerDetail(reportData, startOfDate, endOfMonth, selectedClass) }}
                                >
                                    <LearnerReportCard
                                        reportData={reportData}
                                    />
                                </Grid>
                            </>
                        )
                    })) : (
                    <>
                        <Placeholder                            
                            primaryText="Learner data not found"
                            secondaryText="No data found!"
                            image="assign"
                        ></Placeholder>
                    </>
                )}
            </Grid>
            <Confirmation
                image="error"
                primaryText="Not Assign Assignment!"
                visible={props.alertFlag}
                alert={true}
                timeout={2200}
                toggleModal={(flag) => props.handleAlertFlag(flag)}
            ></Confirmation>
        </>
    );
};

const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        }
    },
});
export default LearnerList;